function firePageView() {
    try {
        const params: Record<string, string> = {
            u: window.location.href,
            r: document.referrer || '',
        };

        const cfkVid = useCookie('cfk_vid');
        if (cfkVid.value) {
            params.v = cfkVid.value;
        }

        const img = new Image(1, 1);
        img.src = 'https://internal.privacybee.com/pv?' + new URLSearchParams(params).toString();
    } catch {
        // never break the app for tracking
    }
}

export default defineNuxtPlugin(() => {
    const router = useRouter();
    router.afterEach(() => {
        nextTick(() => {
            firePageView();
        });
    });
});
